export const isStatusBannerShowing = (pathname: string | undefined, isBelowSmall: boolean | undefined) =>
	!isBelowSmall && !!pathname && !pathname.includes('settings') && !pathname.includes('reporting');
